// v4 governed habit palette (design law § Color). Habits store their color as
// a CSS var reference ('var(--h-clay)') so rings, checks, and washes adapt to
// the active theme for free. Legacy habits (pre-v4) stored raw hexes from the
// old free preset list — habitColor() maps those to the nearest governed hue
// at render time, so existing data inherits the palette without a store
// migration.
export const HABIT_COLORS = [
  { name: 'Clay', value: 'var(--h-clay)' },
  { name: 'Honey', value: 'var(--h-honey)' },
  { name: 'Moss', value: 'var(--h-moss)' },
  { name: 'Sea', value: 'var(--h-sea)' },
  { name: 'Iris', value: 'var(--h-iris)' },
  { name: 'Plum', value: 'var(--h-plum)' },
] as const;

const LEGACY_MAP: Record<string, string> = {
  // the old HabitForm preset list
  '#059669': 'var(--h-moss)',
  '#0f766e': 'var(--h-sea)',
  '#0284c7': 'var(--h-sea)',
  '#d97706': 'var(--h-honey)',
  '#7c3aed': 'var(--h-plum)',
  '#dc2626': 'var(--h-clay)',
  // stray Tailwind hues seen in seeds/fixtures
  '#6366f1': 'var(--h-iris)',
  '#0ea5e9': 'var(--h-sea)',
  '#8b5cf6': 'var(--h-plum)',
  '#14b8a6': 'var(--h-sea)',
  '#f59e0b': 'var(--h-honey)',
};

export function habitColor(color: string): string {
  return LEGACY_MAP[color.toLowerCase()] ?? color;
}
